import { TFunction } from 'i18next'

export const getRegistrationNumberLabel = (countryId: string | undefined, t: TFunction): string => {
  if (countryId === 'NL') {
    return 'KVK'
  }

  if (countryId === 'DE') {
    return 'HRB'
  }

  if (countryId === 'FR') {
    return 'SIRET'
  }

  if (countryId === 'DK') {
    return 'CVR'
  }

  return t('contact.detail.registration_number')
}
